module.exports = __webpack_public_path__ + "img/3.4.NH3-N.7da4a111.png";